import { Component, OnInit, ViewChild } from '@angular/core';
import { MatStepper, StepperOrientation } from '@angular/material/stepper';
import { QuoteGoodsInfoComponent } from './quote-goods-info/quote-goods-info.component';
import { QuoteLogisticsServiceInfoComponent } from './quote-logistics-service-info/quote-logistics-service-info.component';
import { QuoteLogisticsExtraServiceComponent } from './quote-logistics-extra-service/quote-logistics-extra-service.component';
import { QuoteDescriptionsPicturesComponent } from './quote-descriptions-pictures/quote-descriptions-pictures.component';
import { IncotermsIdResponseData } from '@shared/model/incoterms-id-response.model';
import { Subject, Subscription } from 'rxjs';
import { BaseInfoService } from '@api/base-info.service';
import { QuotePersistService } from './quote-persist.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { QuoteExtraService } from '@shared/services/quote-extra-services.service';
import { CustomsService } from '@shared/services/customs.service';
import { CustomsModel } from '@shared/model/customs.model';

@Component({
  selector: 'app-quote-request',
  templateUrl: './quote-request.component.html',
  styleUrls: ['./quote-request.component.scss']
})
export class QuoteRequestComponent implements OnInit {
  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild(QuoteGoodsInfoComponent) goodsInfoComponent: QuoteGoodsInfoComponent;
  @ViewChild(QuoteLogisticsServiceInfoComponent) logisticsServiceInfoComponent: QuoteLogisticsServiceInfoComponent;
  @ViewChild(QuoteLogisticsExtraServiceComponent) logisticsServiceDetailsComponent: QuoteLogisticsExtraServiceComponent;
  @ViewChild(QuoteDescriptionsPicturesComponent) descriptionsPicturesComponent: QuoteDescriptionsPicturesComponent;
  
  stepperOrientation: StepperOrientation = 'horizontal';
  isLinear = true;
  showToast = false;
  quoteRequest = false;
  hsCodeTypeId;
  DangerousShow = false;
  hsCodeList;
  providerIds: number[];
  index;
  isDesktop;
  isExpress;
  isRedirect = false;
  isDocument = false;
  Doc;
  routes = [];
  route;
  destinationAddress;
  originationAddress;
  expressStatus = false;
  language = 'fa';
  files = [];
  customs: CustomsModel[];
  originationClearance = false;
  destinationClearance = false;
  transportTypeId: number;
  titilePicture;
  incoterms: IncotermsIdResponseData[];
  public destroy$ = new Subject<void>();
  private subscription = new Subscription();
  constructor(
    private baseInfoService: BaseInfoService,
    private quotePersistService: QuotePersistService,
    public http: HttpClient,
    private quoteExtra: QuoteExtraService,
    public customsService: CustomsService,
  ){
    this.getValueFieldsOption();
  }

  ngOnInit(){
    this.getExtraService();
  }
  getValueFieldsOption() {
    this.subscription = this.baseInfoService.getQuoteRequest().subscribe(
      (res) => {
        this.quotePersistService.sendQuoteRequestFields(res);
      }
    );
  }
  onStepChange(e) {
    if (e.selectedIndex === 2) {
    }
  }
  getExtraService() {
    const serviceTypeId = this.logisticsServiceInfoComponent.formGroup.controls.serviceTypeId?.value;
    const transportType = this.expressStatus ? 1 : 0;
    const express = this.expressStatus ? 1 : 0;
    const document = this.isDocument ? 1 : 0
    this.http.get(`${environment.baseUrl}/api/v1/base-info/extra-services?serviceType=${serviceTypeId ?
      serviceTypeId : 0}&transportType=${transportType}&express=${express}&document=${document}`).subscribe((res: any) => {
        this.quoteExtra.sendServices(res);
      });
  }
  getIncoterms() {
    this.customsService.getCustoms().subscribe((customs => {
      this.customs = customs;
    }));
    if (this.customs?.length === 2) {
      this.transportTypeId = this.customs[1]?.transportType?.id;
      this.baseInfoService.getIncotermsId(this.transportTypeId).subscribe((result: any) => {
        this.quotePersistService.sendIncoterms(result);
      });
    } else if (this.customs?.length > 2) {
      this.baseInfoService.getIncotermsId().subscribe((result: any) => {
        this.quotePersistService.sendIncoterms(result);
      });
    }
  }
}
